export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}

export function slugify(value: string): string {
  return value
    .toString()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function formatPrice(value: number, locale = 'en-US', currency = 'USD'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function shortId(id: string, length = 6): string {
  return `#${id.slice(0, length).toUpperCase()}`;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

/**
 * Coerce une valeur date hétérogène en millisecondes epoch, ou null si invalide.
 * Gère : nombre (ms ou secondes), Firestore Timestamp ({ seconds } ou .toMillis()),
 * objet Date, et chaîne ISO.
 */
export function toMillis(value: unknown): number | null {
  if (value == null) return null;

  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return null;
    // Heuristique : un timestamp en secondes (~1e9) plutôt qu'en ms (~1e12).
    return value < 1e12 ? value * 1000 : value;
  }

  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isNaN(ms) ? null : ms;
  }

  if (typeof value === 'object') {
    const v = value as { toMillis?: () => number; seconds?: number };
    if (typeof v.toMillis === 'function') return v.toMillis();
    if (typeof v.seconds === 'number') return v.seconds * 1000;
    return null;
  }

  if (typeof value === 'string') {
    const ms = Date.parse(value);
    return Number.isNaN(ms) ? null : ms;
  }

  return null;
}

export function pickReturnBaseUrl(): string {
  if (import.meta.env.VITE_PUBLIC_STORE_BASE_URL) return import.meta.env.VITE_PUBLIC_STORE_BASE_URL;
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}
